var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoRips(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "stethoscope",
    d: "M24,9.5a3.5,3.5,0,1,0-5,3.15V16A5,5,0,0,1,9,16v-.151A7.513,7.513,0,0,0,15,8.5v-5A3.5,3.5,0,0,0,11.5,0H9V3h2.5a.5.5,0,0,1,.5.5v5a4.5,4.5,0,1,1-9,0v-5A.5.5,0,0,1,3.5,3H6V0H3.5A3.5,3.5,0,0,0,0,3.5v5a7.513,7.513,0,0,0,6,7.349V16a8,8,0,0,0,16,0V12.65A3.491,3.491,0,0,0,24,9.5Z",
    fill: "#508cd8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoRips);
export default __webpack_public_path__ + "static/media/icono-rips.51d9e00386716d23d367c9c09efb0419.svg";
export { ForwardRef as ReactComponent };